module.exports = __webpack_public_path__ + "img/3.d5a71136.jpg";